/**
 * StageCreateModal — criar uma etapa do funil (substitui o window.prompt()).
 *
 * Estruturado para crescer: hoje pede só o Nome (+ cor opcional), mas o form já
 * está montado como objeto de estado, então adicionar campos futuros
 * (probabilidade, ganho/perdido, condições de saída) é incremental.
 *
 * Visual: mesmo padrão de modal centrado do módulo Financeiro (fc-modal-*,
 * ../financeiro/contas.css) — cartão branco, borda #e4e7ec, azul #2563eb.
 *
 * Props:
 *   pipelineId  — funil onde a etapa nasce
 *   ordem       — posição inicial (normalmente stages.length)
 *   cor         — cor inicial sugerida (opcional)
 *   onClose()   — fecha sem criar
 *   onCreated(s)— criou a etapa (o board/settings recarregam)
 */

import { useState } from 'react'
import Icon from '../../components/icons.jsx'
import { createStage } from '../../db/api.js'
import '../financeiro/contas.css'
import './pipelines.css'

export default function StageCreateModal({ pipelineId, ordem = 0, cor = null, onClose, onCreated }) {
  const [form, setForm] = useState({ nome: '', cor: cor || '#0071e3', probabilidade: '' })
  const [saving, setSaving] = useState(false)
  const [err, setErr] = useState(null)

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }))

  const create = async () => {
    if (saving) return
    if (!form.nome.trim()) { setErr('Nome é obrigatório.'); return }
    setSaving(true); setErr(null)
    try {
      const probabilidade = form.probabilidade === '' ? null : Number(form.probabilidade)
      const s = await createStage(pipelineId, { nome: form.nome.trim(), ordem, cor: form.cor, probabilidade })
      onCreated(s)
    } catch (e) { setErr(e.message); setSaving(false) }
  }

  return (
    <div className="fc-modal-overlay" onMouseDown={onClose}>
      <div className="fc-modal" style={{ width: 420 }} onMouseDown={(e) => e.stopPropagation()}>
        <div className="fc-modal-head">
          <span className="fc-drawer-title">Nova etapa</span>
          <button className="fc-drawer-x" onClick={onClose}><Icon n="x" s={16} sw={2} /></button>
        </div>
        <div className="fc-modal-body">
          {err && <div className="fc-error">{err}</div>}

          <div className="fc-field">
            <label className="fc-label">Nome da etapa<i>*</i></label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <span className="pm-color-swatch" title="Cor da etapa">
                <input type="color" value={form.cor} onChange={(e) => set('cor', e.target.value)} />
                <span className="pm-color-swatch-dot" style={{ background: form.cor }} />
              </span>
              <input
                className="fc-input" style={{ flex: 1 }} value={form.nome} autoFocus
                onChange={(e) => set('nome', e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') create() }}
                placeholder="Ex.: Qualificação"
              />
            </div>
          </div>

          <div className="fc-field">
            <label className="fc-label">Probabilidade de fechamento <span style={{ fontWeight: 400 }}>(opcional)</span></label>
            <div style={{ position: 'relative', width: 140 }}>
              <input
                className="fc-input" type="number" min="0" max="100" step="1"
                value={form.probabilidade}
                onChange={(e) => set('probabilidade', e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') create() }}
                placeholder="Ex.: 50"
              />
              <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: '#98a2b3', fontSize: 13, pointerEvents: 'none' }}>%</span>
            </div>
          </div>
        </div>
        <div className="fc-modal-foot">
          <button className="fc-ctrl" onClick={onClose}>Cancelar</button>
          <button className="fc-ctrl primary" onClick={create} disabled={saving}>
            {saving ? 'Criando…' : 'Criar'}
          </button>
        </div>
      </div>
    </div>
  )
}
